module.exports = __webpack_public_path__ + "app/images/settings/appearance/elegant_preview.jpg";